import { ReferenceBubble } from "@/Shared/ReferenceNumbers/Bubbles/Internal/ReferenceBubble";

export function AmazonReferenceIdQuestionBubble(props: {
  displayName?: string | undefined;
  small?: boolean | undefined;
}) {
  return (
    <ReferenceBubble
      small={props.small}
      heading={
        props.displayName
          ? `Enter the Amazon reference ID provided by the receiver for your ${props.displayName.toLowerCase()}`
          : `Enter the Amazon reference ID provided by the receiver`
      }
    />
  );
}
